module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACHSURBVHgB7c9hDYAgEAXgpwlsIBFsZBQiGAGaGMEIzARGQNhgQyaK3P30bW/sGHwDgBYBxmhX62pcJxCjAxZ7RLRHW0w2D65rWKvjD8tklri+0ndEZTy2hUuqgC6oTIrZAqoo2B1KxmJnTozlmz9WDismOLE38DP2BDZhJbAZ68I6Zvs7GnMC8wZ05+hKFxUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/pen.png
// module id = 1059
// module chunks = 0